















import { Component, Model, Vue } from 'vue-property-decorator';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import { EPeriodPerformance } from '@/utils/PerformanceUtils';

@Component({
  components: {
    Typography
  }
})
export default class PeriodTabs extends Vue {
  @Model('input', { type: String }) activeTab!: EPeriodPerformance;

  get stringTabs() {
    return this.tabs.map(item => item.label);
  }

  get tabs() {
    return [
      {
        key: EPeriodPerformance.OVERTIME,
        label: 'This year'
      },
      {
        key: EPeriodPerformance.TODAY,
        label: 'Today'
      },
      {
        key: EPeriodPerformance.WEEK,
        label: 'This week'
      },
      {
        key: EPeriodPerformance.MONTH,
        label: 'This month'
      }
    ];
  }
}
